import Vue from 'vue';
import faqs from '@/content/newFaqs';
export const faqMixin = Vue.extend({
    data: () => ({
        faqItems: [],
    }),
    mounted() {
        this.getFaq();
    },
    methods: {
        getFaq() {
            this.faqItems = faqs.flatMap((item) => {
                var _a;
                return (_a = item === null || item === void 0 ? void 0 : item.children) === null || _a === void 0 ? void 0 : _a.flatMap((item) => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.children) === null || _a === void 0 ? void 0 : _a.flatMap((child) => child === null || child === void 0 ? void 0 : child.items); });
            });
        },
    },
});
